import {getAccessToken} from '../../../services/tokens';
import {validateURLString} from '../url';

const httpClientContract = Object.seal({
  get() {
    throw Error('Method not implemented');
  },
  authorizedGet() {
    throw Error('Method not implemented');
  },
  post() {
    throw Error('Method not implemented');
  },
  delete() {
    throw Error('Method not implemented');
  }
});

const getURL = (path, queryParams = {}) => {
  // Are arguments valid
  const isURLValid = validateURLString(path);
  const isValidQueryParams = queryParams
      && typeof queryParams === 'object'
      && !Array.isArray(queryParams);

  if (!isURLValid) {
    console.error(`URl "${path}" is not valid`);
    return null;
  }

  const url = new URL(path);

  if (isValidQueryParams) {
    // We need this function to save URL object to save search our values
    Object.keys(queryParams).forEach(key => {
      const value = queryParams[key];

      if (value) {
        url.searchParams.set(key, queryParams[key]);
      }
    });
  }

  return url;
};

const httpClient = Object.assign(httpClientContract, {
  async get(path, queryParams, params) {

    const url = getURL(path, queryParams);

    try {
      const response = await window.fetch(url.href, params);

      return response.status !== 204 ? await response.json() : Promise.resolve(null);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async authorizedGet(path, queryParams, params) {

    const url = getURL(path, queryParams);

    try {
      const response = await window.fetch(url.href, {
        ...params,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`
        }
      });

      return response.status !== 204 ? await response.json() : Promise.resolve(null);
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async post(path, queryParams, body, withBody, params) {
    const url = getURL(path, queryParams);

    try {
      const response = await window.fetch(url.href, {
        ...params,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`
        },
        body: JSON.stringify(body)
      });

      if (withBody) {
        return await response.json();
      }
      return response;
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async delete(path, queryParams, params) {
    const url = getURL(path, queryParams);

    try {
      const response = await window.fetch(url.href, {
        ...params,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`
        }
      });

      return response.ok;
    } catch (err) {
      return Promise.reject(err);
    }
  }
});

export {
  httpClient
};
